export default "__VITE_ASSET__ry9TH2jE__"